import { type Actions, ActionType } from './profiles.actions';
import { initialState, profileAdapter, type State } from './profiles.state';

export function profilesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_ALL: {
            return {
                ...state,
                isPending: true,
                error: null
            };
        }

        case ActionType.FETCH_ALL_FAILED: {
            return {
                ...state,
                isPending: false,
                isLoaded: false,
                error: action.payload.error
            };
        }

        case ActionType.FETCH_ALL_SUCCEEDED: {
            return profileAdapter.setAll(action.payload.profiles, {
                ...state,
                isPending: false,
                isLoaded: true
            });
        }
        case ActionType.RESET: {
            return {
                ...initialState
            };
        }

        case ActionType.INVALIDATE: {
            return {
                ...state,
                isLoaded: false
            };
        }

        default:
            return state;
    }
}
